module.exports = __webpack_public_path__ + "static/media/rus-flag.bdfea20b.svg";